import React, { useEffect, useState, useRef } from "react";
import CrossIcon from "../../assets/image/svg/cross-icon.svg";
import SupportIcon from "../../assets/image/svg/support-icon.svg";
import RightArrow from "../../assets/image/svg/right-arrow-white.svg";
import TopArrow from "../../assets/image/svg/top_arrow.svg";
import ChatBot from "../orders/Chatbot";
import { motion, AnimatePresence } from "framer-motion";
import { gsap } from "gsap";

const HelpPopUp = () => {
  const chatRef = useRef(null);
  const [showButton, setShowButton] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [isVisible, setIsVisible] = useState(false); // State to show/hide chatbot

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const totalScrollableHeight = documentHeight - windowHeight;

      const percentScrolled = (scrollTop / totalScrollableHeight) * 100;
      setScrollPercent(percentScrolled);
      setShowButton(percentScrolled > 70);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible) {
      gsap.fromTo(
        chatRef.current,
        { autoAlpha: 0, y: 40, scale: 0.9 },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.5,
          ease: "power3.out",
        }
      );
    } else {
      gsap.to(chatRef.current, {
        autoAlpha: 0,
        y: 40,
        scale: 0.9,
        duration: 0.4,
        ease: "power3.in",
      });
    }
  }, [isVisible]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleChatbot = () => {
    setIsVisible((prevState) => !prevState); // Toggle the visibility of the chatbot
  };

  return (
    <div
      className="position-fixed bottom-0 d-flex flex-column align-items-end end-0 mb-4 me-4"
      style={{ zIndex: 1000 }}
    >
      {/* Always show the Chatbot button */}
      {/* Show support button only when chatbot is closed */}
{!isVisible && (
  <div
    className="circle_round cursor_pointer mb-2"
    onClick={toggleChatbot}
    style={{
      position: "relative",
      width: "40px",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img src={SupportIcon} alt="Support" width={30} />
  </div>
)}


      {/* Show Chatbot Component if visible */}
      <AnimatePresence>
  {isVisible && (
  <div ref={chatRef} style={{ display: "block", transformOrigin: "bottom right" }}>
    <ChatBot closeChat={toggleChatbot} />
  </div>
)}

</AnimatePresence>


      {/* Show the back-to-top button when the user scrolls down 70% */}
      {showButton && (
        <div
          className="circle_round cursor_pointer"
          onClick={scrollToTop}
          style={{
            position: "relative",
            width: "40px",
            height: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={TopArrow} alt="back to top" width={30} />
        </div>
      )}
    </div>
  );
};

export default HelpPopUp;
